<div class="page-body">
  <div *ngIf="loading">
    <app-spinner [infoText]="translations.loading"></app-spinner>
  </div>

  <div *ngIf="!loading" class="contents-wrapper">
    <div class="contents-container">
      <div class="success-icon-container">
         <app-zaver-icon [size]="88" name="diamond"></app-zaver-icon>
      </div>

      <div
        *ngIf="state.paymentInformation.paymentMethod == 'INVOICE'"
        class="success-message"
      >
        {{ translations.successTitle }}
      </div>
      <div
        *ngIf="
          state.paymentInformation.paymentMethod == 'CREDIT' ||
          state.paymentInformation.paymentMethod === 'CREDIT_DIRECT_DEBIT'
        "
        class="success-message"
      >
        {{ translations.successTitle }}
      </div>
      <div
        *ngIf="state.paymentInformation.paymentMethod == 'INVOICE'"
        class="info-message"
      >
        {{ translations.successInfo }}
      </div>
      <div
        *ngIf="
          state.paymentInformation.paymentMethod == 'CREDIT' ||
          state.paymentInformation.paymentMethod === 'CREDIT_DIRECT_DEBIT'
        "
        class="info-message"
      >
        {{ translations.successInfo }}
      </div>

      <div class="details-list-wrapper smallest-mobile-hide">
        <hr *ngIf="state" class="details-divider" />
        <div *ngIf="state" class="details-container">
          <div class="details-key-entry">{{ translations.amount }}</div>

          <div *ngIf="state" class="details-value-entry">
            {{ state.totalCheckoutValue | value }}
          </div>
        </div>

        <hr *ngIf="paymentMethod" class="details-divider" />
        <div *ngIf="paymentMethod" class="details-container">
          <div class="details-key-entry">{{ translations.paymentMethod }}</div>

          <div class="details-value-entry">
            {{ paymentMethod }}
          </div>
        </div>

        <hr *ngIf="state" class="details-divider" />
        <div *ngIf="state" class="details-container">
          <div class="details-key-entry">
            {{ state.paymentInformation.title }}
          </div>

          <zaver-button-link
            [text]="translations.detailsLink"
            (click)="toggleModalSelectDetailsTab()"
          >
          </zaver-button-link>
        </div>

        <hr *ngIf="paymentMethod || state" class="details-divider" />

        <div
          *ngIf="successUrl"
          class="merchant-return-link"
        >
          <zaver-button-link
            [text]="getMerchantReturnText()"
            (click)="onRouteToSuccessUrl()"
          ></zaver-button-link>
        </div>
      </div>
    </div>
  </div>
</div>

<zaver-checkout-modal
  *ngIf="selectorItems && modalActive"
  logo="assets/img/Zaver_Logotype_Circle_Coal_DE.svg"
  [buttonText]="translations.closeButton"
  (onClose)="toggleModal()"
>
  <app-selector
    #selector
    [selectedItem]="selectedItem"
    [selectorItems]="selectorItems"
  ></app-selector>
</zaver-checkout-modal>
